// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();


var scrollPosition = window.scrollY;
var logoContainer = document.getElementById('page-header');

window.addEventListener('scroll', function() {

    scrollPosition = window.scrollY;

    if (scrollPosition >= 30) {
        logoContainer.classList.add('scrolled');
    } else {
        logoContainer.classList.remove('scrolled');
    }

});


function checkDivLocation(){
	var $window=$(window);
	var window_bottom=$window.scrollTop()+$window.height();
	$('.fadeUp__top,.fadeIn__top,.fadeInLeft__top,.fadeInRight__top').each(function(i){
		var $that=$(this);
		var div_bottom=$that.position().top+($that.outerHeight()/2);

		if(window_bottom>div_bottom){
			$(this).addClass('visible')
			;}
		});
}
checkDivLocation();

$(window).on('scroll',function(){
	checkDivLocation();
});





var isInViewport = function(elem) {
  var distance = elem.getBoundingClientRect();
  return (
    distance.top >= 0 &&
    distance.left >= 0 &&
    distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    distance.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};
// read the link on how above code works

var fadeInElement = document.querySelectorAll('.fadeUp');
window.addEventListener('scroll', function(event) {
fadeInElement.forEach(element => {
    if (isInViewport(element)) {
      element.classList.add("visible");
    }
});
}, false);



$('.carousel__modal__close').on('click',function(){
	$(this).parent('.carousel__modal').fadeOut().removeClass('active');
	$('.carousel__modal .carousel-item').removeClass('active');
});

$('.show-modal').on('click',function(){
	var itemShow = $(this).attr('data-slide-to');
	$('[data-modal-slide='+itemShow+']').addClass('active');
	$('.carousel__modal').addClass('active').fadeIn();
});

$('.block__people .btn__show').on('click',function(){
	$(this).siblings('.block__people__desc').fadeIn();
	$('body').addClass('no-scroll');
});

$('.block__people .btn__close').on('click',function(){
	$(this).closest('.block__people__desc').fadeOut();
	$('body').removeClass('no-scroll');
});


document.onkeydown = function(evt) {
    evt = evt || window.event;
    if (evt.keyCode == 27) {
        $('.carousel__modal').fadeOut().removeClass('active');
        $('.carousel__modal .carousel-item').removeClass('active');
    }
};